import { BooleanInput } from "react-admin";
import React, { useEffect, useState } from "react";
import { useField } from "react-final-form";
import { LevelResources } from "utils/tools";

const DropOffAuthInput = () => {
  const levelIdField = useField("levelId");
  const dropOffAuthField = useField("dropOffAuth");

  const levelResources = LevelResources(Number(levelIdField.input.value));

  useEffect(() => {
    if (levelIdField.input.value) {
      dropOffAuthField.input.onChange(levelResources.dropOffAuth);
    }
  }, [levelIdField.input.value]);

  return (
    <BooleanInput label="Enable Drop Off Authorization" source="dropOffAuth" />
  );
};

export default DropOffAuthInput;
